import React from 'react'
import PropTypes from 'prop-types'
import USelectPicker from '../USelectPicker'
/**
 * UIconPicker is a control for selecting icon from a list. Has the features below:
 *
 * * Select a single icon from a list.
 * * Select multiple icon from a list.
 * * Autocomplete.
 * * Clear current selection.
 *
 */
export default function UIconPicker(props) {
  const {
    multiple = false,
    placeholder = 'Select...',
    showLabelHelp = false,
    InputLabelHelpProps = {},
  } = props
  return (
    <USelectPicker
      multiple={multiple}
      placeholder={placeholder}
      showLabelHelp={showLabelHelp}
      InputLabelHelpProps={InputLabelHelpProps}
      {...props}
      hideAvatar={false}
    />
  )
}

UIconPicker.propTypes = {
  /** Text to display when nothing is selected. */
  placeholder: PropTypes.string,
  /** Enables the multiple select. Default is false. */
  multiple: PropTypes.bool,
  /** Label of the picker. */
  label: PropTypes.string,
  /** Variant of TextField to use. Default is outlined.*/
  variant: PropTypes.oneOf(['outlined', 'standard', 'filled']),
  /** Callback fired when the value is changed.
   *
   * `event`:
   * The event source of the callback. You can pull out the new value by accessing "event.target.value".
   */
  onChange: PropTypes.func,
  /** Array of to display select on the dropdown.
   * Each option is an object with the following attributes:
   *
   * ```
   * {
   * value: 1,
   * label: 'Sample 1', //First line, typically the name
   * image: 'svg', // image svg string
   * avatar: (  //Avatar object to display.
   *   <Avatar
   *     src={'blob:http://...'} // SVG Icon
   *   />
   *  ),
   *   }
   *```
   *
   */
  options: PropTypes.array,
  /**
   *  To display error message on loading options
   */
  errorLoadingOptions: PropTypes.string,
  /** Show label help */
  showLabelHelp: PropTypes.bool,
  /** Props applied to the input label help element. E.g.  InputLabelHelpProps={{type:'link', label:'Help', link:'unicef.github.io', icon, tooltipTitle: 'Tooltip title', tooltipPlacement: 'bottom}} */
  InputLabelHelpProps: PropTypes.object,
}
